import { useState, useEffect } from 'react';
import './Splash.css';

function Splash({ onFinish }) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
      onFinish();
    }, 10000); // 10 seconds

    return () => clearTimeout(timer);
  }, [onFinish]);

  if (!show) return null;

  return (
    <div className="splash-overlay">
      <div className="splash-container">
        <button className="splash-skip" onClick={() => { setShow(false); onFinish(); }}>
          Skip Intro
        </button>
        <img src="/flier.png" alt="Cyton Academy - Science, Chemistry & Biology Classes" className="splash-image" />
      </div>
    </div>
  );
}

export default Splash;
